"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvinceDetails = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getProvinceDetails(countryIso, province) {
    const { country_info } = (0, checkout_frontend_library_1.getOrderInitialData)();
    const countryInfo = country_info.find(o => o.iso_code === countryIso);
    if (countryInfo) {
        const region = countryInfo.provinces.find(o => (o.name === province || o.iso_code === province));
        if (region) {
            return { code: region.iso_code, name: region.name };
        }
    }
    return { code: '', name: '' };
}
exports.getProvinceDetails = getProvinceDetails;
